import { render } from "./Singup.vue?vue&type=template&id=b7b24688&scoped=true"
import script from "./Singup.vue?vue&type=script&lang=js"
export * from "./Singup.vue?vue&type=script&lang=js"

import "./Singup.vue?vue&type=style&index=0&id=b7b24688&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b7b24688"

export default script